import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { ContentResource as BaseContentResource } from '@jelly/components';
import Loadable from '@loadable/component';
import { BestPickTopCard } from '../Category/mega/BestPickTopCard'; //export directly

export { Link } from '@jelly/ui';
export { DatalotBanner, NextivaBanner } from '@jelly/components';
export var QtWidget = Loadable(function () {
  return import(
  /* webpackChunkName: 'QtWidget' */
  '@jelly/components').then(function (_ref) {
    var QtWidget = _ref.QtWidget;
    return QtWidget;
  });
});
export var RfqWidget = Loadable(function () {
  return import(
  /* webpackChunkName: 'RfqWidget' */
  '@jelly/components/lib/RfqWidget').then(function (_ref2) {
    var RfqWidget = _ref2.RfqWidget;
    return RfqWidget;
  });
});
export var ContentResource = function ContentResource(_ref3) {
  var resource = _ref3.resource,
      type = _ref3.type;
  return /*#__PURE__*/React.createElement(BaseContentResource, {
    resource: resource,
    type: type
  });
};

var BestPickContainer = _styled("div", {
  target: "e1m5rf6h0",
  label: "BestPickContainer"
})("display:flex;flex-wrap:wrap;height:100%;justify-content:center;margin:auto;width:100%;> div{margin-bottom:1rem;width:100%;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.MQ.S;
}, "{> div{width:calc(50% - 1rem);}}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.MQ.L;
}, "{width:90%;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.MQ.XL;
}, "{width:100%;flex-wrap:", function (_ref7) {
  var isLongFormTemplate = _ref7.isLongFormTemplate;
  return isLongFormTemplate ? 'nowrap' : 'wrap';
}, ";> div{width:", function (_ref8) {
  var isLongFormTemplate = _ref8.isLongFormTemplate;
  return isLongFormTemplate && 'calc(1200px / 5 - 18px)';
}, ";}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export var BestPicks = function BestPicks(_ref9) {
  var bestPicks = _ref9.bestPicks,
      template = _ref9.template;
  var MAX_NUMBER_OF_BESTPICKS = 5;
  var firstFiveBestPicks = bestPicks === null || bestPicks === void 0 ? void 0 : bestPicks.slice(0, MAX_NUMBER_OF_BESTPICKS);
  var isLongFormTemplate = template === 'long_form';
  return !!firstFiveBestPicks && /*#__PURE__*/React.createElement(BestPickContainer, {
    id: "best-pick-ribbon",
    isLongFormTemplate: isLongFormTemplate
  }, firstFiveBestPicks.map(function (bestPick, i) {
    var bullets = bestPick.bullets,
        review = bestPick.review,
        _bestPick$review = bestPick.review,
        canonical = _bestPick$review.canonical,
        isReview = _bestPick$review.isReview,
        fullReview = _bestPick$review.review.fullReview,
        title = _bestPick$review.title,
        pricing = _bestPick$review.pricing,
        thumbnail = _bestPick$review.thumbnail,
        tabTitle = bestPick.tabTitle;
    return /*#__PURE__*/React.createElement(BestPickTopCard, {
      key: "bestPick-".concat(i),
      bullets: bullets,
      isJumpLink: false,
      tabTitle: tabTitle,
      review: _objectSpread(_objectSpread({}, review), {}, {
        reviewContent: isReview && fullReview,
        hasReviewEnabled: isReview && !!fullReview
      }),
      reviewPath: canonical,
      pricing: _objectSpread({}, pricing),
      serviceName: title,
      thumbnail: thumbnail.path
    });
  }));
};